import {Component, OnInit} from '@angular/core';
import {SipoService} from "../../services/SipoService";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {NgClass, NgIf} from "@angular/common";
import {IframeDialogComponent} from "../../../shared/iframe-dialog/iframe-dialog.component";
import {SignatureLevel} from "../../model/signer-model";
import {KnobModule} from "primeng/knob";
import {ReactiveFormsModule} from "@angular/forms";
import {FormControl} from '@angular/forms';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-document-item-sign',
    standalone: true,
    imports: [
        NgIf,
        IframeDialogComponent,
        KnobModule,
        ReactiveFormsModule,
        NgClass,
        TranslatePipe
    ],
    templateUrl: './confirm-document-sign.component.html',
    styleUrl: './confirm-document-sign.component.scss'
})
export class ConfirmDocumentSignComponent implements OnInit {

    processId!: string;
    subitemId!: string;
    signType!: string;

    signingUrl: string | null = null;

    progress = 0;
    interval: any;
    succefull: boolean | null = null;
    progressControl = new FormControl(0);
    startTime: number = 0;
    showResult = false


    constructor(public ref: DynamicDialogRef,
                public config: DynamicDialogConfig,
                private sipoService: SipoService,) {
    }

    ngOnInit(): void {
        this.startProgress();
        this.processId = this.config.data['processId'];
        this.subitemId = this.config.data['subitemId'];
        this.signType = this.config.data['signType'];

        this.sipoService.getProcessTypeById(this.processId).subscribe({
            next: value => {

                this.signType = value;

                if (this.signType == SignatureLevel.MAX) {
                    this.signQes();
                } else if (this.signType == SignatureLevel.EXTENDED || this.signType == SignatureLevel.HIGH) {
                    this.signQes();
                } else if (this.signType == SignatureLevel.BASICCERT) {
                    this.signFes();
                } else if (this.signType == SignatureLevel.BASIC) {
                    this.signFes();
                } else {
                    alert("no signing standart selected");
                }
            },
            error: err => {
                console.error(err);
            }
        });

    }


    signFes() {

        console.log('signFes');


        this.sipoService.postSignBasicByType(this.processId, this.subitemId, this.signType).subscribe({
            next: (data) => {
                this.processId = this.config.data['processId'];
                this.setSuccefull(true);
            },
            error: (err) => {
                console.log(err);
                this.setSuccefull(false);
            }
        });


    }

    signFesCert() {

    }

    signAes() {

    }

    signQes() {
        this.sipoService.confirmQESSignProcessItem(this.processId, this.subitemId).subscribe({
            next: data => {
                console.log(data);
                this.signingUrl = data;
                window.open(this.signingUrl, '_blank');
            },
            error: err => {
                console.log(err);
            }
        });
    }

    signConfirm() {
        console.log()
    }


    startProgress() {
        this.startTime = Date.now(); // Startzeit merken
        this.interval = setInterval(() => {
            const current = this.progressControl.value || 0;
            this.progressControl.setValue((current + 5) % 100);
        }, 100);
    }

    setSuccefull(status: boolean) {
        this.succefull = status;

        const elapsed = Date.now() - this.startTime;
        const remaining = 5000 - elapsed;

        if (remaining > 0) {
            setTimeout(() => {
                this.stopProgress();
            }, remaining);
        } else {
            this.stopProgress();
        }
    }

    stopProgress() {
        clearInterval(this.interval);
        this.showResult = true;
    }


    ngOnDestroy() {
        this.ref.close(this.succefull);
    }
}
